import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { AuthService } from './authService'
import { Observable, of } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { InactivityTimeoutService } from './inactivity-timeout.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor (
    private authService: AuthService, 
    private router: Router,
    private inactivityTimeoutService: InactivityTimeoutService
  ) {}

  // BUSCA UN USUARIO AUTENTICADO, DE LO CONTRARIO REDIRIGE A authentication/login
  canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      take(1),
      switchMap((isAuthenticated: boolean) => {
        // console.log('console authguard', isAuthenticated)
        if (isAuthenticated) {
          // No reiniciar timer mientras hay diálogo de reauth pendiente
          if (!this.inactivityTimeoutService.isReauthPending()) {
            this.inactivityTimeoutService.startInactivityTimer()
          }
          
          const allowedRoles = route.data['roles']; 
          // console.log('Roles permitidos:', allowedRoles)
          return this.checkUserRole(allowedRoles)
        } else {
          this.router.navigate(['/authentication/login'])
          return of(false)
        }
      })
    )
  }

  private checkUserRole (rolesArray: string[]): Observable<boolean> {
    const role = localStorage.getItem('role')
    // console.log('Rol en sesión: ', role)
    if (rolesArray && Array.isArray(rolesArray) && role && rolesArray.includes(role) ) {
      return of(true)
    } else {
      this.router.navigate(['/authentication/not-authorized'])
      return of(false)
    }
  }
}
